import { useJsonResource } from './use-json-resource';

/** The list of calculators available for a version, from the calculators.json manifest written at build time. */
export function useCalculators(urlVersion: string | undefined) {
  const { loading, error, data } = useJsonResource<string[]>(urlVersion, 'calculators.json');
  return { loading, error, calculators: data };
}
